import { type IamApi } from '@/features/iam/api/iam-api'
import { Skill, type SkillProps } from './Skill'
import { collection } from '@/infra/collection'
import { type CursorPaged } from '@/infra/paging'
import { Id } from '@/infra/id'
import { mapSkillResourceToProps } from './skill-mappers'

export interface ListSkillsQuery {
  workspaceId: Id
  after?: string | null
  limit?: number
}

export type PrimeSkillFn = (props: Partial<SkillProps>) => Skill | undefined

export class SkillStore {
  readonly skills = collection<Skill, string | undefined, SkillProps>({
    getDataId: (data) => data.id,
    getModelId: (model) => model.id,
    create: () => new Skill(),
  })

  constructor(private readonly _api: IamApi) {}

  forWorkspace(workspaceId: Id) {
    const id = Id.assert(workspaceId)
    return this.skills.filter((x) => x.workspaceId === id)
  }

  async listSkills(
    query: ListSkillsQuery,
    signal?: AbortSignal,
  ): Promise<CursorPaged<Skill>> {
    const response = await this._api.skills.list(
      {
        workspace_id: Id.assert(query.workspaceId),
        after: query.after,
        limit: query.limit,
        order_by: 'name asc',
      },
      signal,
    )
    return {
      data: this.skills.set(response.data.map(mapSkillResourceToProps)),
      next: response.cursor,
      total: response.total,
    }
  }
}
